export default __webpack_public_path__ + "static/media/bg_intro.86a9f132.png";